import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { fetchClientOptionsDict, navigateToClientClaims, navigateToClientContracts } from 'state/actions'
import rt from '../reactable.scss'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import ClaimWizardButton from '../ClaimsWizard/ClaimWizardButton'
import i18n from 'lib/i18n'

const _ = i18n('claimWizardTable')

const formatDateTime = (isoString) => {
    const date = new Date(isoString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
}

class DigitalClaimTable extends React.Component {
    componentDidMount() {
        this.props.fetchClientOptionsDict()
    }

    render() {
        const { claims, onCloseMethod, clientOptionsDict, appLanguage, navigateToClientClaims, navigateToClientContracts } = this.props

        const findStatusIndex = (status, appLanguage) => {
            return (Object.entries(clientOptionsDict.SCHADE_STATUS).find(([key, value]) => value[appLanguage] === status) || [null])[0]
        }

        return (
            <div className={rt.tableContainer}>
                <Table
                    filterable={[
                        'claimDate',
                        'date',
                        'formattedDate',
                        'claimNumber',
                        'clientName',
                        'userName',
                        'contractNumber',
                        'risk',
                        'desciption',
                        'status',
                        'action',
                    ]}
                    filterPlaceholder="Filter"
                    className="noPadding"
                    itemsPerPage={20}
                    sortable={[
                        'claimDate',
                        'date',
                        'claimNumber',
                        'clientName',
                        'userName',
                        'contractNumber',
                        'risk',
                        'desciption',
                        'status',
                        'action',
                    ]}
                    defaultSort={{
                        column: 'date',
                        direction: 'desc',
                    }}
                >
                    <Thead>
                        <Th column="claimDate">{_('claimDate')}</Th>
                        <Th column="date">{_('creationTime')}</Th>
                        <Th column="claimNumber">{_('claimNumber')}</Th>
                        <Th column="clientName">{_('clientName')}</Th>
                        <Th column="contractNumber">{_('contractNumber')}</Th>
                        <Th column="risk">{_('risk')}</Th>
                        <Th column="desciption">{_('description')}</Th>
                        <Th column="status">{_('status')}</Th>
                        <Th column="action">{_('action')}</Th>
                    </Thead>
                    {claims.map((row, index) => ( 
                        <Tr className="centered" key={index}>
                            <Td column="claimDate" value={row.main.claimDate}>
                                {formatDateTime(row.main.claimDate)}
                            </Td>
                            <Td column="formattedClaimDate" style={{ display: 'none' }} value={formatDateTime(row.main.claimDate)}>
                                {formatDateTime(row.main.claimDate)}
                            </Td>
                            <Td column="date" value={row.main.creationDate}>
                                {formatDateTime(row.main.creationDate)}
                            </Td>
                            <Td column="formattedDate" style={{ display: 'none' }} value={formatDateTime(row.main.creationDate)}>
                                {formatDateTime(row.main.creationDate)}
                            </Td>
                            <Td column="claimNumber" value={row.main.claimNumber}>
                                        <a
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => navigateToClientClaims(row.main.clientId, row.main.claimId, row.main.claimNumber)}
                                        >
                                            {row.main.claimNumber}
                                        </a>
                            </Td>
                            <Td column="clientName" value={row.main.clientName}>
                                {row.main.clientName}
                            </Td>
                            <Td column="contractNumber" value={row.main.contractNumber}>
                                <a
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => navigateToClientContracts(row.main.clientId, row.main.contractId)}
                                >
                                    {row.main.contractNumber}
                                </a>
                            </Td>
                            <Td column="risk" value={row.details.riskDescription}>
                                {row.details.riskDescription}
                            </Td>
                            <Td column="desciption" value={row.main.qualification}>
                                {row.main.qualification}
                            </Td>
                            <Td column="status" value={row.main.state}>
                                {row.main.state}
                            </Td>
                            <Td column="action" style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                {Number(findStatusIndex(row.main.state, appLanguage)) === 8 ? (
                                    <ClaimWizardButton
                                        contractId={row.main.contractId}
                                        brokerNumber={row.main.brokerNumber}
                                        clientId={row.main.clientId}
                                        claimNumber={row.main.claimNumber}
                                        onCloseMethod={onCloseMethod}
                                        onGoing={true}
                                        isDigitalTable={true}
                                    />
                                ) : null}
                            </Td>
                        </Tr>
                    ))}
                </Table>
            </div>
        )
    }
}

DigitalClaimTable.propTypes = {
    fetchClientOptionsDict: PropTypes.func.isRequired,
    clientOptionsDict: PropTypes.object,
    appLanguage: PropTypes.string,
    onCloseMethod: PropTypes.func.isRequired,
}

DigitalClaimTable.defaultProps = {
    clientOptionsDict: { SCHADE_STATUS: {} },
}

const mapStateToProps = (state) => ({
    clientOptionsDict: state.client.clientOptionsDict,
    appLanguage: state.app.lang,
})

const mapDispatchToProps = {
    fetchClientOptionsDict,
    navigateToClientClaims,
    navigateToClientContracts
}

export default connect(mapStateToProps, mapDispatchToProps)(DigitalClaimTable)



// WEBPACK FOOTER //
// ./components/claims/digitalClaimTable.jsx